<div class="header" *ngIf="cnpj && loja && passoAtual != 'passo4'">
  <div class="container">
    <div class="box-header">
      <div class="campo-title">
        <div class="title">Pesquisa de satisfação</div>
        <div class="loja">{{loja.name}}</div>
      </div>
      <div class="campo-img">
        <img src="{{loja.mark}}" *ngIf="loja.mark" >
      </div>
    </div>
    <div class="box-header">
      Ajude-nos a melhorar com a sua opinião!
    </div>
    <div class="box-header time-lipse">
      <div class="box" (click)="passoAtual = 'passo1'" [ngClass]="{'ativo':passoAtual != 'passo1'}">
        <div class="circle">
          <img src="../assets/img/circle-ativo.svg">
        </div>
        <div class="text">
          identificação
        </div>
      </div>
      <div class="box" (click)="passoAtual = 'passo2'" [ngClass]="{'ativo':passoAtual == 'passo3'}">
        <div class="circle">
          <img src="../assets/img/circle-ativo.svg" *ngIf="passoAtual == 'passo2' || passoAtual == 'passo3'" >
          <img src="../assets/img/circle.svg"  *ngIf="passoAtual == 'passo1'" >
        </div>
        <div class="text">
          Avaliação
        </div>
      </div>
      <div class="box" (click)="passoAtual = 'passo3'">
        <div class="circle">
          <img src="../assets/img/circle-ativo.svg" *ngIf="passoAtual == 'passo3'" >
          <img src="../assets/img/circle.svg"  *ngIf="passoAtual != 'passo3'" >
        </div>
        <div class="text">
          Comentário
        </div>
      </div>
    </div>
  </div>
</div>

<div class="group" *ngIf="groupCode">
  <div class="header">
    <div class="container">
      <div class="box-header">
        <div class="campo-title">
          <div class="title">Pesquisa de satisfação</div>
        </div>
      </div>
      <div class="box-header">
        Ajude-nos a melhorar com a sua opinião!
      </div>
    </div>
  </div>
  <div class="body">
    <div class="container">
      <div class="form-group" *ngIf="group && group.length > 0">
        <ng-select [items]="group"
          bindLabel="name"
          bindValue="_id"
          placeholder = "Selecione a região"
          [searchable]	= "false"
          [clearable]	= "false"
          (change)="changeRegiao($event)"
          [(ngModel)]="select">
      </ng-select>
      </div>
      <div class="form-group">
        <ng-select [items]="stores"
          bindLabel="name"
          class="store"
          [disabled] = "!stores"
          bindValue="_id"
          placeholder = "Selecione a empresa"
          [searchable]	= "false"
          [clearable]	= "false"
          (change)="changeStore($event)"
          [(ngModel)]="selectLoja">
      </ng-select>
      </div>
      <div class="campo-logo mt-3 text-center finaliado" *ngIf="storeSelecionada" >
        <div class="logo-img" *ngIf="storeSelecionada.mark" [ngStyle]="{'background-image': 'url('+storeSelecionada.mark+')'}"></div>
        <div class="text text-center mt-4">
          {{storeSelecionada.name}}
        </div>
        <a class="btn btn-oppinar mt-4" href="{{storeSelecionada.link}}">
          Avançar
        </a>
      </div>
    </div>
  </div>
</div>

<div class="container" *ngIf="cnpj && loja" >
  <div class="form-group" *ngIf="passoAtual == 'passo1' ">
    <label for="nome" class="nome">Seu nome</label>
    <input type="email" [(ngModel)]="nome"  class="form-control" placeholder="Digite seu nome (opcional)"
      id="nome">
    <button (click)="passoAtual='passo2'" class="btn btn-oppinar">Avançar</button>
  </div>
  <div *ngIf="passoAtual == 'passo2'">
    <div class="form-group">
      <label>Qual é a sua opinião sobre nosso(a):</label>
    </div>
    <div class="form-group" *ngFor="let item of loja.themes; let index = index" >
      <div class="rating text-center">
        <p class="title">{{item.title}}</p>
        <rating [max]="5" [(ngModel)]="item.score" [customTemplate]="tt"></rating>
      </div>
      <div class="form-group mt-4" *ngIf="index == 0 && (loja.sectors && loja.sectors.length > 0)" >
        <label>Setor responsável</label>
        <ng-select [items]="loja.sectors"
             bindLabel="name"
             bindValue="id"
             placeholder = "Selecione o setor (opcional)"
             [searchable]	= "false"
             [clearable]	= "false"
             (change)="onChange($event)"
             [(ngModel)]="select">
        </ng-select>
      </div>
      <div class="form-group" *ngIf="item.score <= 3 && item.score != 0" >
        <label *ngIf="item.questions.length > 0">O que houve de errado?</label>
        <div class="form-group form-check" *ngFor="let check of item.questions">
          <input type="checkbox"  (change)="check.answer = $event.target.checked" [(ngModel)]="check.answer" class="form-check-input" [id]="check.title">
          <label class="form-check-label" [for]="check.title">{{check.title}}</label>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="text-center">Em uma escala de 0 a 10, o quanto você recomendaria a {{loja.name}} para um amigo ou familiar?</label>
      <div class="rating rating-slider text-center">
        <rating [max]="11" [(ngModel)]="escala" [customTemplate]="notas"></rating>
        <ng-template #notas let-i="index" let-v="value">
          <button type="button" class="btn btn-rating btn-{{i <= 6 ? 'vermelho' : i>=9?'azul':'amarelo'}}"
          [ngClass]="{'ativo':i == (v-1)}" >
            {{i}}
          </button>
        </ng-template>
      </div>
    </div>
    <button (click)="passoAtual='passo3'" class="btn btn-oppinar" [disabled]="disable()">Avançar</button>
  </div>
  <div *ngIf="passoAtual == 'passo3'" class="comentario">
    <div class="form-group">
      <label for="comentario">Tem algum comentário adicional?</label>
      <textarea class="form-control" [(ngModel)]="comentario" placeholder="Digite seu comentário (opcional)"
        rows="3"></textarea>
    </div>
    <div class="form-group">
      <label for="exampleFormControlInput1">Se desejar receber um retorno em relação à sua avaliação, insira pelo
        menos um contato abaixo:</label>
      <input type="email" class="form-control" [(ngModel)]="email" placeholder="E-mail (opcional)">
    </div>
    <div class="form-group">
      <input type="tel" class="form-control" [(ngModel)]="telefone" ngxPhoneMaskBr  placeholder="Telefone (opcional)">
    </div>
    <div class="form-group">
      <button class="btn btn-oppinar" (click)="onSubmit()" >
        Enviar
      </button>
    </div>
  </div>
  <div *ngIf="passoAtual == 'passo4'" class="finaliado">
    <div class="logo-img" [ngStyle]="{'background-image': loja.mark?'url('+loja.mark+')':'url(../assets/img/Logo.svg)'}"></div>
    <div class="title">
      Pesquisa de satisfação
    </div>
    <div class="sub-title">
      {{loja.name}}
    </div>
    <div class="mensagem text-center">
      Obrigado pela avaliação! <br>
      Sua opinião é muito importante para nós!
    </div>
    <div class="footer">
      uma pesquisa  <img src="../assets/img/logo-oppinar.svg">
    </div>
  </div>
</div>
<ng-template #tt let-i="index" let-v="value">
  <i class="fas fa-star {{i < v ? 'amarelo' : 'cinza'}}"></i>
</ng-template>

<div class="erro container" *ngIf="!cnpj && !group">
  <img src="../assets/img/Logo.svg" alt="">
  <h1>Atenção!</h1>
  <p>Atenção, ocorreu um erro inesperado, por favor escaneie o QR-Code novamente!</p>
</div>
